// utils/index.js

import Vue from 'vue'
import { Base64 } from 'js-base64'

export const EventBus = new Vue()

export const SubmitInfoOptions = {
  sun: [
    { value: '前' },
    { value: '后' },
    { value: '左' },
    { value: '右' },
    { value: '左前' },
    { value: '左后' },
    { value: '右前' },
    { value: '右后' }
  ],
  wind: [
    { value: '微风或无风' },
    { value: '东风' },
    { value: '东南风' },
    { value: '南风' },
    { value: '西南风' },
    { value: '西风' },
    { value: '西北风' },
    { value: '北风' },
    { value: '东北风' }
  ],
  weather: [
    { value: '晴' },
    { value: '多云' },
    { value: '阴' }
  ],
  image: [
    { value: '清晰稳定' },
    { value: '较清晰稳定' }
  ],
  ground: [
    { value: '柏油' },
    { value: '水泥' },
    { value: '沙石' },
    { value: '土层' }
  ],
  preciseGrade: [
    { value: '一等' },
    { value: '二等' },
    { value: '三等' },
    { value: '四等' }
  ]
}

export const TableFields = {
  detaH: [
    {
      label: '后视',
      field: 'pointFrom'
    },
    {
      label: '前视',
      field: 'pointTo'
    },
    {
      label: '高差 (mm)',
      field: 'detaH'
    },
    {
      label: '视距差 (KM)',
      field: 'dist'
    }
  ],
  surveyPoint: [
    {
      label: '测站编号',
      field: 'pointname'
    },
    // {
    //   label: 'x',
    //   field: 'x'
    // },
    // {
    //   label: 'y',
    //   field: 'y'
    // },
    {
      label: '高程',
      field: 'h'
    },
    // {
    //   label: 'isPKnown',
    //   field: 'isPKnown'
    // },
    {
      label: '已知点',
      field: 'isVKnown'
    }
  ]
}

export function isValidJwt (jwt) {
  if (!jwt || jwt.split('.').length < 3) {
    return false
  }
  const data = JSON.parse(atob(jwt.split('.')[1]))
  const exp = new Date(data.exp * 1000)
  const now = new Date()
  return now < exp
}

// const TargetServer = 'http://121.42.173.111:9101'

export function matchUA (matchString) {
  var ua = window.navigator.userAgent.toLowerCase()
  console.log(ua)
  var re = new RegExp(matchString, 'i')
  return ua.match(re) !== null
}

export function updateRowsPoint (rows, editPoint) {
  var index = rows.indexOf(rows.find(x => x.pointname === editPoint.pristine.name))
  rows[index].pointname = editPoint.updated.name
  rows[index].h = editPoint.updated.h
  rows[index].isVKnown = editPoint.updated.isVKnown
  return { index: index, value: rows[index] }
}

export function updateRowsDetaH (rows, editPoint) {
  var index1 = rows.indexOf(rows.find(x => x.pointFrom === editPoint.pristine.name))
  if (index1 !== -1) {
    rows[index1].pointFrom = editPoint.updated.name
  }
  var index2 = rows.indexOf(rows.find(x => x.pointTo === editPoint.pristine.name))
  if (index2 !== -1) {
    rows[index2].pointTo = editPoint.updated.name
  }
  if (index1 === -1 & index2 === -1) {
    return { indexs: [-1, -1], values: [null, null] }
  } else if (index1 === -1 & index2 !== -1) {
    return { indexs: [-1, index2], values: [null, rows[index2]] }
  } else if (index1 !== -1 & index2 === -1) {
    return { indexs: [index1, -1], values: [rows[index1], null] }
  } else {
    return { indexs: [index1, index2], values: [rows[index1], rows[index2]] }
  }
}

export function base64e (str) {
  return Base64.encode(str)
}

export function base64d (str) {
  return Base64.decode(str)
}

export function base64e4url (str) {
  // return Base64.encode(str)
  return base64e(str).replace('+', '-').replace('/', '_')
}

export function base64d4url (str) {
  // return Base64.decode(str)
  return base64d(str.replace('-', '+').replace('_', '/')).replaceAll('#', '%23')
}

const precisionParamsTemplate = {
  ma: 0,
  mS1: 0,
  mS2: 0,
  mT: 0,
  m_Sigma: 0,
  qtype: true,
  alpha: 0.003
}

export function setPrecisionParams (gradeCode) {
  var params = Object.assign({}, precisionParamsTemplate)
  switch (gradeCode) {
    case 1:
      params.m_Sigma = 0.001
      break
    case 2:
      params.m_Sigma = 0.002
      break
    case 3:
      params.m_Sigma = 0.006
      break
    case 4:
      params.m_Sigma = 0.010
      break
  }
  // params.qtype = true
  // params.alpha = 0.003
  return params
}



// WEBPACK FOOTER //
// ./src/utils/index.js